/**
 * SOMNEIA ANIMATIONS
 * Inspired by Motion Theme
 * Handles scroll-triggered animations and parallax effects
 */

(function() {
  'use strict';

  // Check if user prefers reduced motion
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (prefersReducedMotion) {
    return; // Exit if user prefers reduced motion
  }

  /**
   * Intersection Observer for scroll animations
   */
  function initScrollAnimations() {
    const animatedElements = document.querySelectorAll(
      '.som-fade-in, .som-fade-up, .som-fade-left, .som-fade-right, .som-scale-up, .som-stagger, .som-image-reveal, .som-text-reveal'
    );

    if (animatedElements.length === 0) return;

    const observerOptions = {
      threshold: 0.15,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('som-visible');
          // Optionally unobserve after animation
          // observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    animatedElements.forEach((el) => {
      observer.observe(el);
    });
  }

  /**
   * Parallax effect on scroll
   */
  function initParallax() {
    const parallaxElements = document.querySelectorAll('.som-parallax');

    if (parallaxElements.length === 0) return;

    let ticking = false;

    function updateParallax() {
      parallaxElements.forEach((el) => {
        const rect = el.getBoundingClientRect();
        const scrolled = window.pageYOffset;
        const rate = rect.top * 0.3;

        if (rect.top < window.innerHeight && rect.bottom > 0) {
          el.style.transform = `translate3d(0, ${rate}px, 0)`;
        }
      });

      ticking = false;
    }

    function requestTick() {
      if (!ticking) {
        window.requestAnimationFrame(updateParallax);
        ticking = true;
      }
    }

    window.addEventListener('scroll', requestTick, { passive: true });
  }

  /**
   * Smooth scroll for anchor links
   */
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function (e) {
        const href = this.getAttribute('href');

        if (href === '#' || href === '#!') return;

        const target = document.querySelector(href);

        if (target) {
          e.preventDefault();
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      });
    });
  }

  /**
   * Add animation classes to specific sections automatically
   */
  function autoAddAnimationClasses() {
    // Add fade-up to multicolumn items
    const multicolumnItems = document.querySelectorAll('.multicolumn-list__item');
    multicolumnItems.forEach((item, index) => {
      if (!item.classList.contains('som-fade-up')) {
        item.classList.add('som-fade-up');
        item.style.transitionDelay = `${index * 0.1}s`;
      }
    });

    // Add fade-up to product cards
    const productCards = document.querySelectorAll('.card-wrapper');
    productCards.forEach((card, index) => {
      if (!card.classList.contains('som-fade-up')) {
        card.classList.add('som-fade-up');
        item.style.transitionDelay = `${(index % 4) * 0.1}s`;
      }
    });

    // Add fade-up to testimonial cards
    const testimonialCards = document.querySelectorAll('.testimonials__item');
    testimonialCards.forEach((card, index) => {
      if (!card.classList.contains('som-fade-up')) {
        card.classList.add('som-fade-up');
        card.style.transitionDelay = `${index * 0.15}s`;
      }
    });

    // Add fade-in to rich text sections
    const richTextSections = document.querySelectorAll('.rich-text__blocks');
    richTextSections.forEach((section) => {
      if (!section.classList.contains('som-fade-in')) {
        section.classList.add('som-fade-in');
      }
    });

    // Add fade-up to image-with-text sections
    const imageTextSections = document.querySelectorAll('.image-with-text__content');
    imageTextSections.forEach((section) => {
      if (!section.classList.contains('som-fade-up')) {
        section.classList.add('som-fade-up');
      }
    });
  }

  /**
   * Initialize all animations
   */
  function init() {
    // Wait for DOM to be fully loaded
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
      return;
    }

    // Auto-add animation classes to common elements
    autoAddAnimationClasses();

    // Initialize scroll animations
    initScrollAnimations();

    // Initialize parallax (optional, can be heavy on performance)
    // initParallax();

    // Initialize smooth scroll
    initSmoothScroll();

    // Re-initialize on Shopify section load (for theme editor)
    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:load', function() {
        setTimeout(() => {
          autoAddAnimationClasses();
          initScrollAnimations();
        }, 100);
      });
    }
  }

  // Start initialization
  init();

})();